import React, { useState, useReducer } from "react"
import { parse as parseDate, format as formatDate } from "date-fns"
import humanize from "string-humanize"

import { dictionary } from "../../../helpers/types"
import { formatCurrency } from "../../../helpers/string"
import ContentBox from "../../ContentBox"
// import ValuationList from "../ValuationList"
import EditForm from "./EditForm"
import DocumentsTable from "../../DocumentsTable"
import UploadModal from "../../UploadModal"
import ValidationStatus from "../ValidationStatus"
import ValidateButton from "../ValidateButton"

interface Props {
  asset: dictionary
  role?: string
}

const CreditCard = ({ asset, role }: Props) => {
  const [showEditForm, setShowEditForm] = useState(false)
  const [showUploadModal, setShowUploadModal] = useState(false)
  const [docsVersion, incrementDocsVersion] = useReducer(state => state + 1, 0)

  return (
    <>
      <div className="flex flex-column flex-row-ns items-start-ns">
        <div className="flex-auto">
          <span className={`db light-silver fw4 f5 mb2 ttu -${asset.category_label}`}>{humanize(asset.category_label)}</span>
          <h1 className="page-title">{asset.title}</h1>
        </div>
        {role === "admin" &&
          <ValidateButton id={asset.id} validated={!!asset.validated_at} />
        }
        <button onClick={() => setShowEditForm(true)} className="button -primary -with-icon mv4 mv0-ns">
          <i className="material-icons">edit</i>
          Edit debt
        </button>
      </div>

      <EditForm assetId={asset.id} values={asset} open={showEditForm} onClose={() => setShowEditForm(false)} />

      <ContentBox
        title="Credit card details"
        grid
        renderHeader={() => (
          <ValidationStatus
            type="debt"
            validated={asset.validated}
            validatedAt={asset.validated_at}
            invalidMessage="Upload credit agreement below to validate."
          />
        )}
      >
        <ul className="data-grid">
          <li>
            <div>
              <strong>Provider name</strong><br />
              {asset.provider_name}
            </div>
          </li>
          <li>
            <div>
              <strong>Account number</strong><br />
              {asset.policy_reference ?
                asset.policy_reference
              :
                <span className="light-gray">&ndash;</span>
              }
            </div>
          </li>
          <li>
            <div>
              <strong>Credit amount</strong><br />
              {formatCurrency(asset.current_value)}
            </div>
          </li>
          <li>
            <div>
              <strong>Interest rate</strong><br />
              {(asset.interest_rate || asset.interest_rate === 0) ?
                `${asset.interest_rate}%`
              :
                <span className="light-gray">&ndash;</span>
              }
            </div>
          </li>
          <li>
            <div>
              <strong>Monthly payment</strong><br />
              {formatCurrency(asset.monthly_payment)}
            </div>
          </li>
          {asset.promotional_offer &&
            <>
              <li>
                <div className="-fullwidth">
                  <strong>Promotional offer</strong><br />
                  0% interest until {formatDate(parseDate(asset.offer_expires), "DD/MM/YYYY")}
                </div>
              </li>
              <li>
                <div className="-fullwidth">
                  <strong>Promo offer reminder when ending?</strong><br />
                  {asset.offer_expires_reminder ? "Yes, 1 month before end" : "No"}
                </div>
              </li>
            </>
          }
        </ul>
      </ContentBox>

      {/* <ValuationList valuations={valuations} /> */}

      <ContentBox title="Documents" collapsable extraClasses="mt5">
        <div className="mt4">
          <DocumentsTable
            recordId={asset.id}
            recordType="Asset"
            recordGroup=""
            version={docsVersion}
            onUpdate={incrementDocsVersion}
            onAddNew={() => setShowUploadModal(true)}
          />
        </div>
      </ContentBox>

      <UploadModal
        title="Add document"
        open={showUploadModal}
        documentTypes={["credit_agreement", "monthly_statement"]}
        recordId={asset.id}
        recordType="Asset"
        onUploadComplete={incrementDocsVersion}
        onClose={() => setShowUploadModal(false)}
      />
    </>
  )
}

export default CreditCard
